"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnippetsClient = void 0;
const request_1 = require("./request");
const defaultOptions = {
    version: 'v1',
    userAgent: 'ranna-ts',
    auth: null,
};
/**
 * Request client to perform API requests
 * against the snippet API.
 */
class SnippetsClient extends request_1.RequestClient {
    /**
     * Initialize a new client connected to the passed ranna
     * server endpoint.
     *
     * You can specify additional options like the API version
     * (default 'v1'), the user agent header or the authorization
     * header, if required.
     *
     * @param endpoint The ranna snippets server endpoint.
     * @param options Additional options.
     */
    constructor(endpoint, options = defaultOptions) {
        super(endpoint, options);
    }
    /**
     * Creaates an account with the given username and returns
     * the account properties including the account master key.
     *
     * This masterkey is exchanged againbst an API key later,
     * which can be reviewed and regenerated. Also, the master
     * key is required to delete an account.
     *
     * The masterkey is only shown ONCE at account creation
     * and CAN NOT BE REVIEWED AGAIN AFTER THAT!
     *
     * @param username
     * @returns
     */
    createAccount(username) {
        return this.request('PUT', `users/${username}`);
    }
    /**
     * Exchanges the passed master key for the passed username
     * against an API key which is used for subsequent requests.
     *
     * The API key can also be regenerated using this endpoint
     * if already existent.
     *
     * You can set `store` to true to stroe the received API
     * key in the request client.
     *
     * @param username
     * @param masterkey
     * @param store
     * @returns
     */
    exchangeAPIToken(username, masterkey, store = false) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clientOptions.auth = 'bearer ' + masterkey;
            let res = null;
            try {
                res = yield this.request('POST', `users/${username}/apitoken`);
                return res;
            }
            catch (err) {
                throw err;
            }
            finally {
                if (store && !!res)
                    this.clientOptions.auth = 'bearer ' + res.token;
                else
                    this.clientOptions.auth = null;
            }
        });
    }
    /**
     * Deletes the user wtih the passed username if the passed
     * masterkey matches the account.
     *
     * @param username
     * @param masterkey
     * @returns
     */
    deleteAccount(username, masterkey) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clientOptions.auth = 'bearer ' + masterkey;
            let res = null;
            try {
                res = yield this.request('DELETE', `users/${username}`);
                return res;
            }
            catch (err) {
                throw err;
            }
            finally {
                this.clientOptions.auth = null;
            }
        });
    }
    /**
     * Returns a list of snippets belonging to the
     * authorized account.
     *
     * This endpoijt must be authorized with an API
     * token.
     *
     * @returns
     */
    list() {
        return this.request('GET', 'snippets');
    }
    /**
     * Reqeusts a sinlie snippet by ident or id.
     * @param ident
     * @returns
     */
    get(ident) {
        return this.request('GET', `snippets/${ident}`);
    }
    /**
     * Creates a new snippet with the passed content.
     * @param snippet
     * @returns
     */
    create(snippet) {
        return this.request('POST', 'snippets', snippet);
    }
    /**
     * Updates a snippet with the passed content.
     * @param snippet
     * @returns
     */
    update(snippet) {
        return this.request('POST', `snippets/${snippet.ident}`, snippet);
    }
    /**
     * Deletes a snipped by its ident or ID.
     *
     * This endpoint required authorization by the owner of
     * the snippet. If the snippet was created anonymously,
     * it can not be deleted!
     *
     * @param ident
     * @returns
     */
    delete(ident) {
        return this.request('DELETE', `snippets/${ident}`);
    }
}
exports.SnippetsClient = SnippetsClient;
